import $ from 'cash-dom'

export default class ContactDetails {
  constructor({ $container } = {}) {
    this.$container = $container
    this.activeNum = null

    this.constructElements()
    this.constructEvents()
  }

  static init() {
	// NEED
    const $containers = $(ContactDetails.selectors.container)

    if ($containers.length) {
      $containers.each((i, elem) => {
        const constructed = new ContactDetails({ $container: $(elem) })
      })
    }
  }

  constructElements() {
	// NEED
    this.$items = this.$container.find(ContactDetails.selectors.item)
    this.$filters = this.$container.find(ContactDetails.selectors.filter)
  }

  constructEvents() {
	// NEED
	console.log('asas');
    this.$container
      .on('click', ContactDetails.selectors.filter, (e) => this.handleClickFilter({ e }))
  }

  doFilterItems({ $container, $filter, categoryNum }) {
	// NEED
    this.activeNum = categoryNum
	categoryNum = !categoryNum ? 0 : categoryNum * 1

    $container
      .find(ContactDetails.selectors.item)
      .prop('checked', false)

    $container
      .find(ContactDetails.selectors.item).eq(categoryNum)
      .prop('checked', true)

    $container
      .find(ContactDetails.selectors.filter)
      .removeClass(ContactDetails.classes.activeButton)

    $filter
      .addClass(ContactDetails.classes.activeButton)
  }

  handleClickFilter({ e }) {
	// NEED
    e.preventDefault()
    const $container = $(e.currentTarget).closest(ContactDetails.selectors.container)
    const $filter = $(e.currentTarget).closest(ContactDetails.selectors.filter)
    const categoryNum = $filter.data('num')

    if (categoryNum !== this.activeNum) {
      this.doFilterItems({ $container, $filter, categoryNum })
    }
  }
}

ContactDetails.selectors = {
  container: '.js-contact-details',
  item: '.js-form-radios__item',

  filter: '.js-contact-details-form-tab',
}

ContactDetails.classes = {
  activeButton: 'c-contact-details__form-tab--active',
}
